function facetsPriceRange() {

    const rangeInput = document.querySelectorAll(".js-price-range .range-input input");

    let priceGap = 1;

    rangeInput.forEach(input => {
        input.addEventListener("input", e => {
            let minVal = parseInt(rangeInput[0].value),
                maxVal = parseInt(rangeInput[1].value);
            if (e.target.classList.contains("field__input-price-min")) {
                //if (minVal >= maxVal) minVal = parseInt(rangeInput[1].value)
                console.log(e);
                e.target.nextElementSibling.classList.remove('active');
                e.target.classList.add('active');
                e.target.closest('.js-price-range').querySelector('.range-slider-min .value').textContent = minVal;
            } else {
                //if (maxVal <= minVal) maxVal = parseInt(rangeInput[0].value)  
                console.log(e);

                e.target.previousElementSibling.classList.remove('active');
                e.target.classList.add('active');
                e.target.closest('.js-price-range').querySelector('.range-slider-max .value').textContent = maxVal;
            }
            if (maxVal - minVal < priceGap) {
                if (e.target.classList.contains("field__input-price-min")) {
                    rangeInput[0].value = maxVal - priceGap;
                } else {
                    rangeInput[1].value = minVal + priceGap;
                }
            }

        });
    });

    const rangeInputMobile = document.querySelectorAll(".js-price-range-mobile .range-input input");

    let priceGapMobile = 1;

    rangeInputMobile.forEach(input => {
        input.addEventListener("input", e => {
            let minValMobile = parseInt(rangeInputMobile[0].value),
                maxValMobile = parseInt(rangeInputMobile[1].value);
            if (e.target.classList.contains("field__input-price-min")) {
                e.target.closest('.js-price-range-mobile').querySelector('.range-slider-min .value').textContent = minValMobile;
            } else {
                e.target.closest('.js-price-range-mobile').querySelector('.range-slider-max .value').textContent = maxValMobile;
            }
            if (maxValMobile - minValMobile < priceGapMobile) {
                if (e.target.classList.contains("field__input-price-min")) {
                    rangeInputMobile[0].value = maxValMobile - priceGapMobile;
                } else {
                    rangeInputMobile[1].value = minValMobile + priceGapMobile;
                }
            }

        });
    });
}

facetsPriceRange();